import { dashboard } from 'types';
import AppConstants from 'constants/AppConstants';
import dashboardProtos from 'utils/protos';

const { EmailExportRequest } = dashboardProtos;

export function getEmailOptInDownloadToken(
  emailExportRequest: dashboard.EmailExportRequest
): ApiAction {
  const request = EmailExportRequest.fromObject(emailExportRequest);
  return {
    TockApi: {
      postProto: '/communication/optin/export',
      request,
      type: AppConstants.COMMUNICATION_OPTIN_EXPORT,
    },
  };
}

export function setEmailOptInSettings(enableOptIn: boolean): ApiAction {
  return {
    TockApi: {
      putProto: `/communication/optin/global?requestOptIn=${enableOptIn}`,
      type: AppConstants.COMMUNICATION_OPTIN_SET_REQUESTS_OPTIN,
      toast: 'Settings saved',
    },
  };
}
